// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { stripeBaseUrl } from '.'


type UpdatePaymentMethodResponse = (SuccessResponse & {}) | FailedResponse

export class UpdatePaymentMethodRequest extends Request {
    private constructor(token: string, init?: RequestInit) { super(`${stripeBaseUrl}/payment/${token}`, init) }
    static async init(token: string, method: Partial<CreditCard>, init?: RequestInit) {
        return new UpdatePaymentMethodRequest(token, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(method)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<UpdatePaymentMethodResponse>(await response.json())
        console.info("Update Payment Method:", data)
    
        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}